// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "meals-Epb9P";
var _5 = "meals_singleMeal-2rTZu";
var _6 = "meal-1eos2";
var _7 = "infoMessage-s2uGW";
var _8 = "infoMessage__htmlMessage-29CJp";
var _9 = "meals_purchased-3ge1r";
export { _1 as "__esModule", _2 as "tablet", _3 as "mobile", _4 as "meals", _5 as "meals_singleMeal", _6 as "meal", _7 as "infoMessage", _8 as "infoMessage__htmlMessage", _9 as "meals_purchased" }
export default { "__esModule": _1, "tablet": _2, "mobile": _3, "meals": _4, "meals_singleMeal": _5, "meal": _6, "infoMessage": _7, "infoMessage__htmlMessage": _8, "meals_purchased": _9 }
